import { IPartnerData, IPartnerForm } from '../models';

export function mapPartnerForm(partner: IPartnerData): IPartnerForm {
	const {
		id,
		shortName,
		formalName,
		website,
		logoUrl,
		contractDto,
		adminCount,
		adminCountLimit,
		surveyCountLimit,
		partnerUserCount,
		partnerUserCountLimit,
		clientCount,
		comment,
		clientCountLimit,
		surveyCount,
		surveyLimitPerClientDtos,
		primaryColor,
		useAdditionalLogo,
		additionalLogoUrl,
	} = partner;

	return {
		id,
		shortName,
		formalName,
		website,
		comment,
		adminCount,
		adminCountLimit: `${adminCountLimit}`,
		partnerUserCount,
		partnerUserCountLimit: `${partnerUserCountLimit}`,
		clientCount,
		clientCountLimit: `${clientCountLimit}`,
		surveyCount,
		surveyCountLimit: `${surveyCountLimit}`,
		contractStartDate: contractDto?.startDate,
		contractEndDate: contractDto?.endDate,
		contract: contractDto?.fileKey,
		logo: logoUrl,
		primaryColor,
		optionalHeaderLogo: additionalLogoUrl,
		useOptionalHeaderLogo: useAdditionalLogo,
		...surveyLimitPerClientDtos?.reduce(
			(res, limitPerClient, i) => ({
				...res,
				[`surveyCountLimit${i + 1}`]: limitPerClient,
			}),
			{},
		),
	};
}
